import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {ContactComponent} from './contact/contact.component';
import {DogsComponent} from './dogs/dogs.component';
import {NewsComponent} from './news/news.component';
import {LittersComponent} from './litters/litters.component';
import {LinksComponent} from './links/links.component';
import {DogPedigreeComponent} from './dog-pedigree/dog-pedigree.component';
import {PhotoComponent} from './photo/photo.component';
import { HttpModule, JsonpModule } from '@angular/http';

const appRoutes: Routes = [
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'contact', component: ContactComponent},
  {path: 'news', component: NewsComponent},
  {path: 'dogs', component: DogsComponent},
  {path: 'pedigree', component: DogPedigreeComponent},
  {path: 'litters', component: LittersComponent},
  {path: 'photo', component: PhotoComponent},
  {path: 'links', component: LinksComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
